import axios from "axios";
import { alignPropType } from "react-bootstrap/esm/types";
import AppRoutes from "../AppRoutes";

export const api = axios.create({
  // baseURL: "http://10.3.1.214:3333",
  baseURL: process.env.REACT_APP_BACKEND,
  strictSSL: false,
});

export const api2 = axios.create({
  // baseURL: "http://10.3.1.214:3333",
  baseURL: process.env.REACT_APP_BACKEND2,
  strictSSL: false,
});

export const apiCEP = axios.create({
  baseURL: "https://viacep.com.br",
});

export const verificaCEP = async (N_cep) => {
  const cepValido = await apiCEP.get(`/ws/${N_cep}/json`);
  return cepValido;
};
export const createSession = async (email, chave) => {
  //console.log({ cpf, chave });
  return api.post(
    "/logarNotas",
    { email, chave },
    { headers: { "Access-Control-Allow-Origin": true } },
  );
};

export const PegarDados1 = async () => {
  console.log("Y");
  const resultado = await api.get("/query");
  console.log("Z == ", resultado);
  return resultado;
};

export const status2 = async () => {
  const resultado = await api.get("/status2");
  return resultado.data;
};

export const PegarDados2 = async (di, df) => {
  const resultado = await api.post("/query2", {
    inicio: di,
    fim: df,
  });
  return resultado;
};

export const pegar_media_serie = async (_gra, _ser) => {
  const resultado = await api2.post("/pegar_media_dis_serie", {
    gra: _gra,
    ser: _ser,
  });
  return resultado;
};

export const pegar_medias_turmas = async (_tur, _un) => {
  const resultado = await api2.post("/pegar_media_dis_turma", {
    turma: _tur,
    unidade: _un,
  });
  return resultado;
};

export const Pegar_boletim = async (Nmat, Nciclo, Nano) => {
  const resultado = await api2.post("/pega_boletim", {
    matricula: Nmat,
    ciclo: Nciclo,
    ano: Nano,
  });
  return resultado;
};

export const pegar_dados_aluno = async (n_matricula) => {
  const resultado = await api2.post("/pegar_dados_aluno", {
    matricula: n_matricula,
  });
  return resultado;
};

export const buscaFoto = async (n_matricula) => {
  const resultado = await api2.post("/fotoAluno", { matricula: n_matricula });
  return resultado.data;
};

export const pegar_disciplinas_aluno = async (_gra, _ser) => {
  const resultado = await api2.post("/pegar_disciplinas_aluno", {
    gra: _gra,
    ser: _ser,
  });
  return resultado;
};

export const pegar_notas_aluno = async (n_matricula) => {
  const resultado = await api2.post("/pegar_notas_aluno", {
    matricula: n_matricula,
  });
  return resultado;
};

export const permite_acesso = async (Nusuario, Ntoken, Npagina) => {
  const resultado = await api.post("/permite_acesso", {
    usuario: Nusuario,
    token: Ntoken,
    pagina: Npagina,
  });
  return resultado.data;
};

export const lista_alunos = async (_cod_uni) => {
  const resultado = await api.post("/queryNota13", {
    unidade: _cod_uni,
  });
  return resultado;
};

export const total_monitora = async (di, df) => {
  const resultado = await api.post("/query3", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const percent_lancamento_rede = async (av) => {
  const resultado = await api.post("/queryNota1", {
    avaliacao: av,
  });
  return resultado.data;
};

export const percent_lancamento_rede_unidade = async (av) => {
  const resultado = await api.post("/percentAvaliaUnidade", {
    avaliacao: av,
  });
  return resultado.data;
};

export const busca_prazo_avaliacao = async (av) => {
  const resultado = await api.post("/queryNota4", {
    avaliacao: av,
  });
  return resultado.data;
};

export const busca_notas_no_prazo = async (av) => {
  const resultado = await api.post("/busca_notas_no_prazo", {
    sig: av,
  });
  return resultado.data;
};

export const busca_notas_no_prazo_rede = async (av) => {
  const resultado = await api.post("/busca_notas_no_prazo_rede", {
    sig: av,
  });
  return resultado.data;
};

export const busca_detalhe_lancamento = async (av, un, ser) => {
  console.log("dados:", av, un, ser);
  const resultado = await api.post("/queryNota5", {
    avaliacao: av,
    unidade: un,
    serie: ser,
  });
  return resultado.data;
};

export const busca_aluno_sem_nota = async (un, sig, dis, tu) => {
  const resultado = await api.post("/alunos_sem_nota", {
    dis: dis,
    unidade: un,
    sig: sig,
    tur: tu,
  });
  return resultado.data;
};

export const pega_ranking_soma = async () => {
  const resultado = await api.post("/somatorio", {});
  return resultado.data;
};

export const pega_ranking_soma_bolsa = async () => {
  const resultado = await api.post("/somatorioBolsa", {});
  return resultado.data;
};

export const pega_matriz_curricular = async () => {
  const resultado = await api.post("/matrizCurricular", {});
  return resultado.data;
};

export const total_medio_ciclo = async () => {
  const resultado = await api.post("/queryNota3", {});
  return resultado.data;
};

export const busca_media_disciplina_ciclo = async (un, ser) => {
  const resultado = await api.post("/queryNota6", {
    unidade: un,
    serie: ser,
  });
  return resultado.data;
};

export const busca_media_comparativa_serie = async (av, un, ser) => {
  console.log("dados:", av, un, ser);
  const resultado = await api.post("/queryNota7", {
    avaliacao: av,
    unidade: un,
    serie: ser,
  });
  return resultado.data;
};

export const busca_media_comparativa_geral = async (av) => {
  const resultado = await api.post("/queryNota8", {
    avaliacao: av,
  });
  return resultado.data;
};

export const busca_alunos_rec2 = async (un, ser, av, nc) => {
  const resultado = await api.post("/queryNota9", {
    avaliacao: av,
    unidade: un,
    serie: ser,
    nota_de_corte: nc,
  });
  return resultado.data;
};

export const busca_qtd_alunos_rec2 = async (un, ser, av, nc) => {
  const resultado = await api.post("/queryNota10", {
    avaliacao: av,
    unidade: un,
    serie: ser,
    nota_de_corte: nc,
  });
  return resultado.data;
};

//-------------
export const fidelizacao = async (di, df) => {
  const resultado = await api.post("/query4", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const novos_renovados = async (di, df) => {
  const resultado = await api.post("/query5", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const novos_renovados_unidade = async (di, df) => {
  const resultado = await api.post("/query14", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const novos_renovados_total = async (di, df) => {
  const resultado = await api.post("/query20", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const novos_renovados_segmento_total = async (di, df) => {
  const resultado = await api.post("/query43", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const novos_renovados_serie_rede = async (di, df) => {
  const resultado = await api.post("/query46", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const novos_renovados_unidade_23 = async (di, df) => {
  const resultado = await api.post("/query19", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const bolas_detalhes = async (di, df, un) => {
  const resultado = await api.post("/query11", {
    inicio: di,
    fim: df,
    unidade: un,
  });
  return resultado.data;
};

export const faturamento1 = async (di, df) => {
  const resultado = await api.post("/query50", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const bolas_detalhes_rede = async (di, df, un) => {
  const resultado = await api.post("/query49", {
    inicio: di,
    fim: df,
    unidade: un,
  });
  return resultado.data;
};

export const alunos_andamento = async (di, df, un) => {
  const resultado = await api.post("/query32", {
    inicio: di,
    fim: df,
    unidade: un,
  });
  return resultado.data;
};

export const bolsas_media_unidade = async (di, df) => {
  const resultado = await api.post("/query17", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const bolsas_media_unidade_contribuinte = async (di, df) => {
  const resultado = await api.post("/query22", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const bolsas_diretor_unidade = async (di, df) => {
  const resultado = await api.post("/query16", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const bolsas_diretor_unidade_novos = async (di, df) => {
  const resultado = await api.post("/query23", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const bolsas_diretor_unidade_renovados = async (di, df) => {
  const resultado = await api.post("/query24", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const bolsas_balcao_unidade = async (di, df) => {
  const resultado = await api.post("/query15", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const bolsas_balcao_unidade_novos = async (di, df) => {
  const resultado = await api.post("/query25", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const bolsas_balcao_unidade_renovados = async (di, df) => {
  const resultado = await api.post("/query26", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const bolsas_bolsao_unidade = async (di, df) => {
  const resultado = await api.post("/query27", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const bolsas_bolsao_unidade_novos = async (di, df) => {
  const resultado = await api.post("/query28", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const metas_unidades = async (di, df) => {
  const resultado = await api.post("/query31", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const anuidade_unidades = async (di, df) => {
  const resultado = await api.post("/query30", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const bolsas_bolsao_unidade_renovados = async (di, df) => {
  const resultado = await api.post("/query29", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const fidelizacao_turma = async (di, df, un) => {
  const resultado = await api.post("/query12", {
    inicio: di,
    fim: df,
    unidade: un,
  });
  return resultado.data;
};

export const fidelizacao_serie = async (di, df, un) => {
  const resultado = await api.post("/query44", {
    inicio: di,
    fim: df,
    unidade: un,
  });
  return resultado.data;
};

export const fidelizacao_serie_rede = async (di, df) => {
  const resultado = await api.post("/query45", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const fidelizacao_seg_rede = async (di, df) => {
  const resultado = await api.post("/query47", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const fidelizacao_seg_unidade = async (di, df, un) => {
  const resultado = await api.post("/query48", {
    inicio: di,
    fim: df,
    unidade: un,
  });
  return resultado.data;
};

export const bolsa_unidade = async (di, df, un) => {
  const resultado = await api.post("/query13", {
    inicio: di,
    fim: df,
    unidade: un,
  });
  return resultado.data;
};

export const bolsas = async (di, df) => {
  const resultado = await api.post("/query6", {
    inicio: di,
    fim: df,
  });
  return resultado;
};

export const pagamentos_pix = async (di, df, st) => {
  const resultado = await api.post("/query40", {
    inicio: di,
    fim: df,
    status: st,
  });
  return resultado.data;
};

export const pagamentos_credito = async (di, df, st) => {
  const resultado = await api.post("/query41", {
    inicio: di,
    fim: df,
    status: st,
  });
  return resultado.data;
};

export const agendamentos = async (un, td) => {
  const resultado = await api.post("/query42", {
    unidade: un,
    status: td,
  });
  return resultado.data;
};

export const bolsas_rede = async () => {
  const resultado = await api.post("/query37");
  return resultado;
};
export const bolsas_rede_novos = async () => {
  const resultado = await api.post("/query38");
  return resultado;
};
export const bolsas_rede_renovados = async () => {
  const resultado = await api.post("/query39");
  return resultado;
};

export const renovacao_serie_compara = async () => {
  const resultado = await api.post("/query51");
  return resultado;
};

export const bolsas_tipo = async (di, df) => {
  const resultado = await api.post("/query18", {
    inicio: di,
    fim: df,
  });
  return resultado;
};

export const bolsas_tipo_unidade_novos = async (di, df) => {
  const resultado = await api.post("/query35", {
    inicio: di,
    fim: df,
  });
  return resultado;
};

export const bolsas_tipo_unidade_renovados = async (di, df) => {
  const resultado = await api.post("/query36", {
    inicio: di,
    fim: df,
  });
  return resultado;
};

export const bolsas_tipo_novos = async (di, df) => {
  const resultado = await api.post("/query33", {
    inicio: di,
    fim: df,
  });
  return resultado;
};

export const bolsas_tipo_renovados = async (di, df) => {
  const resultado = await api.post("/query34", {
    inicio: di,
    fim: df,
  });
  return resultado;
};

export const bolsas_media = async (di, df) => {
  const resultado = await api.post("/query7", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const alunos_situacao = async (di, df) => {
  const resultado = await api.post("/query8", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const material = async () => {
  const resultado = await api.post("/query10");
  return resultado.data;
};

export const mensalidade_media = async (di, df) => {
  const resultado = await api.post("/query9", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const mensalidade_media_rede = async (di, df) => {
  const resultado = await api.post("/query21", {
    inicio: di,
    fim: df,
  });
  return resultado.data;
};

export const permite_acesso_fondation = async (Npagina, Nunidade) => {
  console.log("npagina", Npagina);
  const resultado = await api.post("/permite_acesso", {
    pagina: Npagina,
    unidade: Nunidade,
  });
  console.log("resultado1", resultado.data);
  if (resultado.data === true) return true;
  else return false;
};

export const envia_CC = async (n_id) => {
  const resultado = await api.post("/sendCC", { id: n_id });
  return resultado;
};

export const lista_proventos = async (n_cpf) => {
  console.log("recebi_cpf:", n_cpf);
  const resultado = await api.post("/lista_proventos", { cpf: n_cpf });
  return resultado.data;
};

export const lista_funcionarios = async () => {
  const resultado = await api.post("/lista_funcionarios");
  return resultado.data;
};

export const consulta_funcionario = async (n_cpf) => {
  const resultado = await api.post("/consulta_funcionario", { cpf: n_cpf });
  return resultado.data;
};

export const salva_funcionario = async (n_cpf) => {
  const resultado = await api.post("/salva_funcionario", { cpf: n_cpf });
  return resultado.data;
};

export const lista_matriculas = async (n_cpf) => {
  const resultado = await api.post("/lista_matricula", { cpf: n_cpf });
  return resultado.data;
};

export const adiciona_matricula = async (n_cpf, n_matricula) => {
  const resultado = await api.post("/adiciona_matricula", {
    cpf: n_cpf,
    matricula: n_matricula,
  });
  return resultado.data;
};

export const remove_matricula = async (n_cpf, n_matricula) => {
  const resultado = await api.post("/apaga_matricula", {
    cpf: n_cpf,
    matricula: n_matricula,
  });
  return resultado.data;
};

export const gravar_chave = async (Ntoken, Nchave) => {
  const resultado = await api.post("/grava_chave", {
    token: Ntoken,
    chave: Nchave,
  });
  return resultado;
};

export const validaToken = async (N_token) => {
  const resultado = await api.post("/valida_token", {
    token: N_token,
  });
  return resultado;
};

export const enviar_reset = async (Nemail) => {
  const resultado = await api.post("/reset_senha", {
    email: Nemail,
  });
};

export const uploadArq = async (Nmes, Nano, Ntipo, Narq) => {
  const restulado = await api.post("/upload_arq", {
    mes_ref: Nmes,
    ano_ref: Nano,
    tipo_doc: Ntipo,
    arquivo: Narq,
  });
};

export const contaDocs = async () => {
  const resultado = await api.get("/proventos_cadastrados");
  return resultado.data;
};

export const listaDocs = async (Nmes, Nano, Ntipo, Nnome) => {
  console.log("X", Nmes, Nano, Ntipo, Nnome);
  const resultado = await api.post("/proventos_usuarios", {
    mes_ref: Nmes,
    ano_ref: Nano,
    tipo_doc: Ntipo,
    nome: Nnome,
  });
  return resultado.data;
};

/*
export const lista_unidadeCPF = async (n_cpf) => {
  const resultado = await api.post("/lista_unidadeCPF", { cpf: n_cpf });
  return resultado.data;
};

export const lista_usuario = async (Nunidade) => {
  const resultado = await api.post("/lista_usuarios", { unidade: Nunidade });
  return resultado.data;
};

export const dados_usuario = async (n_cpf) => {
  const resultado = await api.post("/dados_usuario", { cpf: n_cpf });
  return resultado.data;
};

export const grava_usuario = async ({ dados }) => {
  const resultado = await api.post("/gravar_usuario", { dados });
  return resultado;
};

export const lista_unidades = async () => {
  const resultado = await api.post("/lista_unidades");
  return resultado.data;
};

export const lista_perfil_usuario = async (Ncpf, Nunidade) => {
  const resultado = await api.post("/perfil_usuario", {
    cpf: Ncpf,
    unidade: Nunidade,
  });
  return resultado.data;
};

export const atualiza_perfil_usuario = async (Ncpf, Ncod, Nuni, Nstatus) => {
  const resultado = await api.post("/atualiza_perfil", {
    cpf: Ncpf,
    cod_perfil: Ncod,
    unidade: Nuni,
    marcado: Nstatus,
  });
  return resultado;
};

export const gravar_chave = async (Ntoken, Nchave) => {
  const resultado = await api.post("/grava_chave", {
    token: Ntoken,
    chave: Nchave,
  });
  return resultado;
};

export const enviar_reset = async (Nemail) => {
  const resultado = await api.post("/reset_senha", {
    email: Nemail,
  });
};

export const lista_Pessoas = async () => {
  const resultado = await api.get("/lista_Pessoa");
  return resultado;
};

export const grava_Pessoa = async (dados) => {
  const resultado = await api.post("/gravar_pessoa", dados);
  return resultado;
};

export const grava_email = async (dados) => {
  const resultado = await api.post("/gravar_email", dados);
  return resultado;
};

export const grava_telefone = async (dados) => {
  const resultado = await api.post("/gravar_telefone", dados);
  return resultado;
};

export const grava_endereco = async (dados) => {
  const resultado = await api.post("/gravar_endereco", dados);
  return resultado;
};

export const constulta_Pessoa = async (nid) => {
  const resultado = await api.get(`/consulta_pessoa/${nid}`);
  return resultado;
};

export const atualiza_pessoa = async (nid, dados) => {
  const resultado = await api.post(`/atualiza_pessoa/${nid}`, dados);
  return resultado;
};

export const atualiza_endereco = async (nid, dados) => {
  const resultado = await api.post(`/atualiza_endereco/${nid}`, dados);
  return resultado;
};

export const constulta_Email = async (nid) => {
  const resultado = await api.get(`/consulta_email/${nid}`);
  return resultado;
};

export const remove_email = async (nid) => {
  const resultado = await api.delete(`/apaga_email/${nid}`);
  return resultado;
};

export const constulta_Telefone = async (nid) => {
  const resultado = await api.get(`/consulta_telefone/${nid}`);
  return resultado;
};

export const remove_telefone = async (nid) => {
  const resultado = await api.delete(`/apaga_telefone/${nid}`);
  return resultado;
};

export const constulta_endereco = async (nid) => {
  const resultado = await api.get(`/consulta_endereco/${nid}`);
  return resultado;
};



export const pegarStatus = async () => {
  return api.get("/status");
};

export const novoAcesso = async (N_email) => {
  return api.post("/acesso", { email: N_email });
};

export const sendMail = async (opcao) => {
  return api.post(
    "/sendmail",
    { opcao },
    { headers: { "Access-Control-Allow-Origin": true } }
  );
};

export const consultaCpf = async (N_CPF) => {
  return api.post("/consultaCpfPsmce", { cpf: N_CPF });
};

export const validaToken = async (N_token) => {
  const emailValido = await api.get(`/validaToken/${N_token}`);
  return emailValido.data.email;
};

export const confirmaToken = async (N_token) => {
  const emailValido = await api.get(`/validaToken/${N_token}`);
  return emailValido;
};

export const DadosCPFSMCE = async (N_CPF) => {
  const resultado = await api.post("/consultaCpfPsmce", { cpf: N_CPF });
  return resultado;
};

export const gravarNovaPessoa = async ({ dados, token }) => {
  const resultado = await api.post("/confirmar", { dados, token });
  return resultado;
};

export const gerarChave = async (token) => {
  const resultado = await api.post("/gerarChave", token);
  return resultado;
};

export const resetChave = async (email) => {
  const resultado = await api.post("/ResetChave", email);
  return resultado;
};

export const existeCadastro = async (n_email) => {
  const resultado = await api.post(
    "/emailemPessoa",
    { email: n_email },
    { headers: { "Access-Control-Allow-Origin": true } }
  );
  return resultado.data;
};

export const consultaPessoa = async (n_cpf) => {
  const resultado = await api.post("/consultaCpfPessoa", { cpf: n_cpf });
  return resultado.data;
};

export const consultaAluno = async (n_mat) => {
  const resultado = await api.post("/dadosAluno", { matricula: n_mat });
  // console.log("dmat", n_mat);
  return resultado.data;
};

export const consultaPendenciaCpf = async (n_cpf) => {
  const resultado = await api.post("/pendenciaCpf", { cpf: n_cpf });
  if (resultado.data.length === 0) {
    return false;
  } else {
    return true;
  }
};

export const listaMatriculasCPF = async (n_cpf) => {
  const resultado = await api.get(`/cadastro/${n_cpf}`);
  return resultado.data;
};

export const buscardadosAluno = async (n_matricula) => {
  const resultado = await api.post("/dadosAluno", { matricula: n_matricula });
  return resultado.data;
};

export const gravaPessoa = async ({ dados }) => {
  const resultado = await api.post("/gravarCpf", { dados });
  return resultado;
};

export const buscarDadosContrato = async (n_matricula) => {
  const resultado = await api.post("/dadosContrato", {
    matricula: n_matricula,
  });
  return resultado.data;
};

export const gravaAluno = async ({ dados }) => {
  const resultado = await api.post("/gravarAluno", { dados });
  return resultado;
};

export const gravaContrato = async ({ dados }) => {
  const resultado = await api.post("/gravarContrato", { dados });
  return resultado;
};

export const buscaPlano = async (n_matricula) => {
  const resultado = await api.post("/dadosPlano", { matricula: n_matricula });
  return resultado.data;
};

export const mostrarPDFContrato = async (n_matricula) => {
  const resultado = await api.post("/contratoPdf", { matricula: n_matricula });
  return resultado.data;
};

export const consultaAgenda = async (n_dia, n_unidade) => {
  const resultado = await api.post("/consultaAgenda", {
    dia: n_dia,
    unidade: n_unidade,
  });
  return resultado.data;
};

export const gravaAgenda = async (n_dia, n_unidade, n_matricula) => {
  console.log("apiM", n_matricula);

  const resultado = await api.post("/AtualizaAgenda", {
    dia: n_dia,
    unidade: n_unidade,
    matricula: n_matricula,
  });
  return resultado.data;
};

export const enviarPDFContrato = async (n_matricula) => {
  const resultado = await api.post("/sendPDF", { matricula: n_matricula });
  return resultado.data;
};

export const verificaAgenda = async (n_matricula) => {
  const resultado = await api.post("/verificaAgenda", {
    matricula: n_matricula,
  });
  return resultado.data;
};

export const buscaUnidade = async (n_matricula) => {
  const resultado = await api.post("/unidade", { matricula: n_matricula });
  return resultado.data;
};

export const buscaFoto = async (n_matricula) => {
  const resultado = await api.post("/fotoAluno", { matricula: n_matricula });
  return resultado.data;
};
*/
